import { useNavigate, useParams, Link } from 'react-router-dom';
import { useState } from 'react';
import { ArrowLeft, CreditCard, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import type { MedioPago } from '@condo/contracts';
import { useIniciarPago } from '@/features/pagos/api';
import { useCondoContext } from '@/features/auth/use-condo-context';
import { PageContainer } from '@/components/common/page-container';
import { PageHeader } from '@/components/common/page-header';
import { Button } from '@/components/ui/button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Label } from '@/components/ui/label';

export function IniciarPagoRoute() {
  const { cargoId } = useParams();
  const navigate = useNavigate();
  const { condoId } = useCondoContext();
  const [medio, setMedio] = useState<MedioPago>('webpay_plus');
  const mutation = useIniciarPago();

  async function iniciar() {
    if (!cargoId) return;
    try {
      const res = await mutation.mutateAsync({
        cargoId,
        body: {
          cargoUnidadId: cargoId,
          medio,
          returnUrl: `${window.location.origin}/app/condominios/${condoId}/mis-cargos`,
        },
      });
      toast.info('Redirigiendo a pasarela de pago (mock)');
      navigate(`/app/condominios/${condoId}/pagos/mock-checkout/${res.pagoId}`);
    } catch {
      toast.error('No se pudo iniciar el pago');
    }
  }

  return (
    <PageContainer width="form">
      <Button variant="ghost" asChild size="sm" className="mb-4">
        <Link to={`/app/condominios/${condoId}/mis-cargos`}>
          <ArrowLeft className="h-4 w-4" />
          Volver
        </Link>
      </Button>
      <PageHeader
        eyebrow="Pago"
        title="Elegir medio de pago"
        subtitle="En el MVP, los medios de pago estan mockeados. En produccion se integraran Khipu y WebPay Plus via puerto hexagonal."
        noRule
      />

      <div className="rounded-md border border-[var(--color-hairline)] bg-[var(--color-paper)] p-6">
        <Label>Medio de pago</Label>
        <Select value={medio} onValueChange={(v) => setMedio(v as MedioPago)}>
          <SelectTrigger className="mt-1.5">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="webpay_plus">WebPay Plus</SelectItem>
            <SelectItem value="khipu">Khipu</SelectItem>
            <SelectItem value="transferencia_manual">Transferencia manual</SelectItem>
          </SelectContent>
        </Select>

        <Button
          size="lg"
          className="mt-6 w-full"
          onClick={iniciar}
          disabled={mutation.isPending}
        >
          {mutation.isPending ? (
            <>
              <Loader2 className="h-4 w-4 animate-spin" />
              Conectando...
            </>
          ) : (
            <>
              <CreditCard className="h-4 w-4" />
              Iniciar pago
            </>
          )}
        </Button>
      </div>
    </PageContainer>
  );
}
